import * as React from "react";

import styles from "./Toolbar.scss";

interface IProps {
    children?: React.ReactNode[] | React.ReactNode;
}

const Toolbar: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.toolbar}>
        {props.children}
    </div>
);

export default Toolbar;


// WEBPACK FOOTER //
// ./src/Components/Common/Toolbar/Toolbar.tsx